import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

const inputVariants = cva(
	[
		"border-input file:text-foreground placeholder:text-muted-foreground/70 flex w-full min-w-0 rounded-md border bg-transparent dark:bg-white/2 dark:text-foreground shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
		"focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
		"aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
		"read-only:bg-accent",
	],
	{
		variants: {
			size: {
				md: "h-9 px-3 py-1 text-sm",
				lg: "h-12 px-4 py-2",
			},
		},
		defaultVariants: {
			size: "md",
		},
	},
);

function Input({
	className,
	size,
	type,
	...props
}: Omit<React.ComponentProps<"input">, "size"> &
	VariantProps<typeof inputVariants>) {
	return (
		<input
			type={type}
			data-slot="input"
			className={inputVariants({
				size,
				className: [
					type === "search" &&
						"[&::-webkit-search-cancel-button]:appearance-none [&::-webkit-search-decoration]:appearance-none [&::-webkit-search-results-button]:appearance-none [&::-webkit-search-results-decoration]:appearance-none",
					type === "file" &&
						"text-muted-foreground/70 file:border-input file:text-foreground p-0 pr-3 italic file:me-3 file:h-full file:border-0 file:border-r file:border-solid file:bg-transparent file:px-3 file:text-sm file:font-medium file:not-italic",
					className,
				],
			})}
			{...props}
		/>
	);
}

export { Input };
